export const setupScrollAnimations = () => {
  const elements = document.querySelectorAll('section');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.animationPlayState = 'running';
        observer.unobserve(entry.target); // une seule fois
      }
    });
  }, { threshold: 0.1 });

  elements.forEach((el) => {
    el.style.animationPlayState = 'paused'; // par défaut
    observer.observe(el);
  });
};
